import type { FunctionComponent } from "react";

import { GoogleAnalyticsScripts } from "./google-analytics/scripts";
import { GoogleTagManagerScripts } from "./google-tag-manager/scripts";

export * from "./atoms";
export * from "./hooks";

export const TrackingScripts: FunctionComponent = () => (
  <>
    <GoogleTagManagerScripts />
    <GoogleAnalyticsScripts />
  </>
);

TrackingScripts.displayName = "TrackingScripts";
